export function calculatePayout(athletes, wager, setMultiplier, setProtectedMultipliers, multiplierType) {
  let multiplier = 0;
  let protectedMuliplier = 0;

  // Check if athlete.easy or athlete.hard in athletes
  const easy = athletes.find((x) => x.easy);
  const hard = athletes.find((x) => x.hard);
  const promo = athletes.find((x) => x.promo);
  const athleteCount = athletes.length;
  const loggedIn = document.body.classList.contains('logged-in');
  const shark = $('#shrk').val () > 1;

  if ((easy || hard || promo) && loggedIn) {
    let countMultiplier = 0;
    let easyCount = 0;
    let hardCount = 0;
    for (let athlete of athletes) {
      let thisMultiplier = 0.75;
      if (athlete.easy) {
        thisMultiplier = 0.25;
        easyCount++;
      }
      if (athlete.promo) {
        thisMultiplier = 0.41;
        // easyCount++;
      }
      if (athlete.hard) {
        thisMultiplier = 1.75;
        hardCount++;
      }
      countMultiplier += 0.5;
      multiplier += thisMultiplier + countMultiplier;
    }

    if (easyCount > 0 && athleteCount > 2) {
      multiplier -= easyCount * 1.75;
    }

    if (easyCount > 0 && athleteCount < 3) {
      multiplier -= easyCount * 1;
    }

    if (easyCount === 1 && athleteCount === 3) {
      multiplier -= 0.5;
    }

    if (easyCount === 2 && athleteCount === 2) {
      multiplier = 1.3;
    }

    if (easyCount === 3 && athleteCount === 3) {
      multiplier = 1.7;
    }
    if (easyCount === 4 && athleteCount === 4) {
      multiplier = 2;
    }
    if (easyCount === 5 && athleteCount === 5) {
      multiplier = 3.2;
    }
    if (easyCount === 6 && athleteCount === 6) {
      multiplier = 4;
    }

  } else {
    switch (athletes.length) {
      case 2:
        multiplier = 3;
        protectedMuliplier = 3;
        break;
      case 3:
        multiplier = 5;
        setProtectedMultipliers([2, 1]);
        protectedMuliplier = 2;
        break;
      case 4:
        multiplier = 10;
        setProtectedMultipliers([5, 1.5]);
        protectedMuliplier = 5;
        break;
      case 5:
        multiplier = 15;
        setProtectedMultipliers([6, 2, 0.4]);
        protectedMuliplier = 6;
        break;
      case 6:
        multiplier = 20;
        setProtectedMultipliers([8, 2, 0.4]);
        protectedMuliplier = 8;
        if (wager == 1 && !shark) {
          multiplier = 50;
        }
        break;
    }
  }

  const boost = sessionStorage.getItem('boost');
  if (boost) {
    const boostPercent = parseFloat(boost);
    if (boostPercent > 0) {
      multiplier = multiplier + (multiplier * (boostPercent / 100));
    }
  }

  if (multiplierType === "protected") {
    setMultiplier(protectedMuliplier);
    return Math.round(wager * protectedMuliplier);
  }

  multiplier = parseFloat(multiplier.toFixed(1));
  setMultiplier(multiplier);
  // Ensure multiplier is never negative
  if (multiplier < 0) {
    multiplier = 1;
  }

  return Math.round(wager * multiplier);
}